import axios from 'axios'
import { getSavedState, saveState } from '../store-utils'

export const state = {
  cachedGroups: getSavedState('device.groups'),
  selectedGroup: null,
}

export const getters = {
  cachedGroups(state) {
    return state.cachedGroups
  },
  selectedGroup(state) {
    return state.selectedGroup
  },
}

export const mutations = {
  SET_CACHE(state, devices) {
    state.cachedGroups = devices
    saveState('device.groups', devices)
  },

  SET_SELECTED(state, group) {
    state.selectedGroup = group
  },
}

export const actions = {
  selectGroup({ commit, state, rootState }, { group }) {
    commit('SET_SELECTED', group)
  },

  fetchGroups({ commit, state, rootState }, { clearCache }) {
    // 1. Check if we've already fetched and cachedGroups the device groups.
    const matchedGroup = state.cachedGroups

    if (!clearCache && matchedGroup) {
      return Promise.resolve(matchedGroup)
    }

    // 2. Fetch the devices from the API and cache it in case
    // we need it again in the future.
    return axios
      .get('/api/services/app/DeviceGroup/GetAll')
      .then((response) => {
        const groups = response.data.items
        commit('SET_CACHE', groups)
        return groups
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          // commit('SET_CACHE', null)
        }
        return null
      })
  },

  updateGroup({ commit, dispatch, state, rootState }, { group }) {
    return axios
      .put('/api/services/app/DeviceGroup/Update', group)
      .then((response) => {
        dispatch('fetchGroups', { clearCache: true }).then((resp) => {
          commit('SET_SELECTED', null)
        })
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          // commit('SET_CACHE', null)
        }
        return null
      })
  },
}
